import React from 'react';

import { useTranslate } from 'react-admin';
import { InputAdornment } from '@material-ui/core';

import { NumberInputEx } from './NumberInputEx';


export const NumberWithSuffixInput = ({ suffix, ...props }) => {
    const translate = useTranslate();

    const endAdornment = (
        <InputAdornment
            position="end"
        >
            <span>{translate(`osfc.fields.suffix.${suffix}`)}</span>
        </InputAdornment>
    );

    return (
        <NumberInputEx {...props} InputProps={suffix ? { endAdornment } : undefined} />
    );
};
